import {httpGetProject} from '@/features/projects/http/projects.http'
import {ProjectExtended} from '@/features/projects/types'
import {QUERY_KEYS} from '@/queryClient'
import {ResponseType} from '@/types'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'

interface UseGetProjectOptions {
    urlParams: {
        projectId: string
    }
    params: {
        responseType: ResponseType
    }
    options?: Omit<UseQueryOptions<ProjectExtended>, 'queryKey' | 'queryFn'>
}

export const useGetProject = ({urlParams, params, options}: UseGetProjectOptions) =>
    useQuery({
        queryKey: [QUERY_KEYS.PROJECT, urlParams.projectId, params],
        queryFn: () => httpGetProject({urlParams, params}),
        ...options
    })
